import axios from "../../../interceptors";
import { LOGIN } from "../../../constants/router";

export const postLoginUser = (pageLoad = {}) => {
  return axios.post(LOGIN, pageLoad);
};
